module.exports = __webpack_public_path__ + "img/9_uk.67919372.svg";